import styles from "./TransparentButton.module.css";

function TransparentButton(props) {
  const buttonClassName = props.className
    ? props.className
    : styles["transparent-button"];
  return (
    <>
      <button
        type={props.type}
        onClick={props.onClick}
        className={`${
          props.disabled ? styles["disabled-button"] : buttonClassName
        }`}
        style={props.style}
        disabled={props.disabled}
        title={props.title}
      >
        {props.children}
      </button>
    </>
  );
}

export default TransparentButton;
